import React, { useMemo } from 'react';
import { useQuery } from 'react-query';
import { StatsContext } from "../../utils";
import { formatPlayerStats } from "../../../shared/utils";
import { d3PlayerByIdsAPI } from '../../../shared/api/variables';
import { fetchClient } from '../../../shared/api/fetching';
import { apiURL } from '../../../shared/api/variables';

const PlayerStatsData = ({ children,
  clubs,
  clubsData,
  clubSportecId,
  seasons,
  season,
  competitions,
  currentQueryType,
  updateFilter,
  resetFilters,
  statType,
  position,
  appearances,
  weather,
  dateRange,
  versus,
  desc,
  page,
  isOpen,
  competitionSlug,
  competitionSportecId,
  statsData,
  preSelectedClub,
  mlsPhaseType,
  baseUrl
}) => {
  const playersData = useMemo(() => {
    return statsData?.map(player => {
      return formatPlayerStats(player, null, null, mlsPhaseType);
    })
  }, [statsData])

  const playerIds = useMemo(() => {
    return statsData?.map(player => player.player_id)
  }, [statsData])

  const d3PlayersEndpoint = d3PlayerByIdsAPI({ playerIds });

  const { data: forgePlayerList } = useQuery({
    queryKey: ['forgePlayerList', playerIds],
    queryFn: () => fetchClient({ endpoint: d3PlayersEndpoint, apiURL: apiURL.d3SportsAPI }),
    enabled: !!playerIds?.length,
    select: (data) => {
      return new Map(data?.map(player => [player.sportecId, player]));
    }
  })

  const mergedPlayersData = useMemo(() => {
    return playersData?.map(statsPlayer => {
      const forgePlayer = forgePlayerList?.get(statsPlayer.sportecId)
      const { thumbnail } = forgePlayer || {}
      return {
        ...statsPlayer,
        player: {
          ...statsPlayer.player,
          image: thumbnail,
          slug: forgePlayer?.playerSlug,
          playerUrl: forgePlayer?.playerSlug
            ? baseUrl
              ? `${baseUrl}/players/${forgePlayer?.playerSlug}`
              : `${window.origin}/players/${forgePlayer?.playerSlug}`
            : null,
        },
      };
    })
  }, [playersData, forgePlayerList])


  return (
    <StatsContext.Provider
      value={{
        clubs,
        clubsData,
        seasons,
        competitions,
        currentQueryType,
        updateFilter,
        resetFilters,
        competitionSportecId,
        competitionSlug,
        season,
        statType,
        clubSportecId,
        position,
        isOpen,
        page,
        playersData: mergedPlayersData,
        desc,
        appearances,
        weather,
        dateRange,
        versus,
        preSelectedClub,
        mlsPhaseType
      }}>
      {
        React.Children.map(children, child => {
          return !child
            ? null
            : typeof child.type === 'string'
              ? child
              : React.cloneElement(child);
        })
      }
    </StatsContext.Provider>
  );
};

export default PlayerStatsData;
